import { motion } from "framer-motion";
import { useLang } from "@/App";
import { Logo } from "@/components/Navbar";

export default function Footer() {
    const { t, lang, setLang } = useLang();
    return (
        <footer className="relative border-t border-[#212b45] overflow-hidden" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
                <div className="grid md:grid-cols-3 gap-10 items-start">
                    <div>
                        <div className="flex items-center gap-3">
                            <Logo size={36} />
                            <span className="font-display font-bold tracking-[0.22em] text-sm">
                                KIBER <span className="neon-text">AI</span>
                            </span>
                        </div>
                        <p className="text-sm text-slate-400 mt-4">{t.footer.tagline}</p>
                        <div className="kana text-[#fcee0a]/60 text-sm tracking-[0.4em] mt-2">キバー・アイ</div>
                        <div className="flex border border-[#212b45] rounded-full overflow-hidden font-mono2 text-[10px] w-max mt-5">
                            <button
                                data-testid="footer-lang-ua"
                                onClick={() => setLang("ua")}
                                className={`px-3.5 py-1.5 transition-colors ${lang === "ua" ? "bg-[#d7ff35] text-[#080a12] font-bold" : "text-slate-400 hover:text-white"}`}
                            >
                                UA
                            </button>
                            <button
                                data-testid="footer-lang-en"
                                onClick={() => setLang("en")}
                                className={`px-3.5 py-1.5 transition-colors ${lang === "en" ? "bg-[#d7ff35] text-[#080a12] font-bold" : "text-slate-400 hover:text-white"}`}
                            >
                                EN
                            </button>
                        </div>
                    </div>
                    <div className="font-mono2 text-[10px] tracking-[0.2em] text-slate-500 space-y-3">
                        <div className="flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#49f5e8] pulse-dot" />
                            {t.footer.latency}
                        </div>
                        <div>{t.footer.uptime}</div>
                        <div>{t.footer.build}</div>
                    </div>
                    <div className="font-mono2 text-[10px] tracking-[0.2em] text-slate-500 space-y-3 md:text-right">
                        <div>MODEL // GPT-5.4-MINI</div>
                        <div>CORE // OPENAI NEURAL NET</div>
                        <div>SHELL // REACT + FASTAPI</div>
                        <div className="script-pink text-2xl tracking-normal pt-2">{t.footer.signature}</div>
                    </div>
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4 }}
                className="font-display font-black uppercase text-center leading-none select-none outline-text text-[19vw] tracking-tight -mb-[4vw]"
                aria-hidden="true"
            >
                KIBER AI
            </motion.div>
            <div className="border-t border-[#212b45] relative bg-[#080a12]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-wrap justify-between gap-3 font-mono2 text-[9px] tracking-[0.25em] text-slate-600">
                    <span>© 2026 {t.footer.rights}</span>
                    <a href="/privacy" data-testid="footer-privacy-link" className="hover:text-[#49f5e8] transition-colors">
                        {lang === "ua" ? "КОНФІДЕНЦІЙНІСТЬ" : "PRIVACY"}
                    </a>
                    <span>{t.footer.tagline}</span>
                </div>
            </div>
        </footer>
    );
}
